const initDiaCalendario = () => {
    const calendario = document.querySelector(".mi-cuenta__calendario-mes__middle-container");

    if (!calendario) return;

    const diaSemana = document.querySelectorAll(".dia-semana-top");

    diaSemana.forEach(dia => {
        dia.addEventListener("click", (e) => {
            diaSemana.forEach(d => d.classList.remove("active"));
            e.target.classList.add("active");

            const diaId = e.target.getAttribute("data-id");
            const bloqueDia = document.querySelectorAll(".bloque-dia");
            bloqueDia.forEach(bloque => {
                if (bloque.getAttribute("data-id") === diaId) {
                    bloque.style.display = "block";
                } else {
                    bloque.style.display = "none";
                }
            });
        });
    });
}

export default initDiaCalendario;